module.exports = {
  CONTENTFUL_URL:
    "https://cdn.contentful.com/spaces/1kuqy4565yvu/environments/master/entries?access_token=3h21GkDEWBBtsOE9491UGYMpArpxq06-jB3mQd6afug",
};
